import BasicResources from './basic-resources';

// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
class Resources {
    // createResources() should create a static field for each resource:
    //
    //    const env = parentEnv || Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();

    static createResources(parentEnv) {
        const env = parentEnv || Resources.env;

        const BASE_URL = '@SchoolUsageReportsGatewayBaseUrl';
        const CERTIFICATE_GATEWAY_URL = '@CertificateGatewayBaseUrl';

        Resources.classOverview = env.resource('overview')
            .baseUrl(BASE_URL)
            .service('/school/classroom/usage');

        Resources.classDetails = env.resource('classDetails')
            .baseUrl(BASE_URL)
            .service('/school/classroom/{classroomId}/usage/date-range');

        Resources.academicYear = env.resource('academicYear')
            .baseUrl(BASE_URL)
            .service('/school/academicYear');

        Resources.participationReport = env.resource('participationReport')
            .baseUrl(BASE_URL)
            .service('/school/student/{profileId}/usage');

        Resources.studentCertificates = env.resource('studentCertificates')
            .baseUrl(BASE_URL)
            .service('/school/classroom/{classroomId}/certificates');

        Resources.studentCertificatesGemCount = env.resource('studentCertificatesGemCount')
            .baseUrl(CERTIFICATE_GATEWAY_URL)
            .service('/new-certificates/gemCounts');

        /**
         * Gets Configuration Item
         * @params: key: configuration item key
         */
        Resources.getConfigurationItem = async key => env.getConfigurationItem(key);
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.

    static initialise(envName, credentials) {
        Resources.env = BasicResources.initialise(envName, credentials);

        Resources.createResources();

        return Resources.env;
    }
}

export default Resources;




// WEBPACK FOOTER //
// ./helpers/resources.js